import { Input } from "antd";
import "./styles.scss";
import { useRef, useState } from "react";
import { CloseCircle } from "iconsax-react";
import { t } from "i18next";
export default function DBTagInput({ value, onChange }) {
    const [focus, setFocus] = useState(false);
    const [input, setInput] = useState("");
    const inputRef = useRef();

    const applyTagHandle = (focusAgain) => {
        if (!value.includes(input) && input.trim().length > 0) {
            onChange([
                ...value,
                {
                    id: value.length + 1,
                    caption: input.trim(),
                },
            ]);
            setInput("");
            focusAgain && inputRef.current.focus();
        }
    };
    return (
        <div
            className={`db-tag-input ${focus ? "focused" : ""}`}
            onClick={() => inputRef.current.focus()}
        >
            {value?.map((tag) => (
                <div className="tag">
                    {tag.caption}{" "}
                    <button
                        onClick={() =>
                            onChange(value.filter((t) => t.id !== tag.id))
                        }
                    >
                        <CloseCircle size={16} />
                    </button>
                </div>
            ))}
            <input
                placeholder={t("type.and.enter")}
                ref={inputRef}
                type="text"
                onFocus={() => setFocus(true)}
                onBlur={() => {
                    setFocus(false);
                    applyTagHandle(false);
                }}
                onChange={(e) => setInput(e.target.value)}
                value={input}
                onKeyUp={(e) => e.key === "Enter" && applyTagHandle(true)}
            />
        </div>
    );
}
